const templates =  {
    "shop.okraina.ru": {
        title: "Мои заказы",
        tags: [
            {
                name: "description",
                content: "",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
    "dostavka.okraina.ru": {
        title: "Мои заказы",
        tags: [
            {
                name: "description",
                content: "",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
}

export default templates;